import React, { Component } from 'react';
import DocIntegrationMain from './DocIntegrationMain';

class DocDemo extends Component {

    constructor(props) {
        super(props)
        this.state = { textDocInteg: null }
    }

    componentDidMount() {
        const textDocInteg = new Request('https://pages.github.psa-cloud.com/wid00/wid-simulation/demojs.md');
        fetch(textDocInteg).then(
            (response) => {
                if (!response.ok) {
                    return;
                }
                return response.text();
            }
        ).then((text) => {this.setState({ textDocInteg: text })})
        .catch(error => {});
    }

    headingsHash = [];

    render() {
        return (
            <DocIntegrationMain textDocInteg={this.state.textDocInteg} id="modalDocDemo" />
        )
    }
}

export default (DocDemo);
